// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal-style layout (matches signup / forget-password modals) */
.Login {
  background-color: transparent;
  height: auto;
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}
.Login p {
  font-size: 22px !important;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  width: 85%;
  margin: 0px auto 1rem;
  font-family: "Raleway";
  font-size: 13px;
}

#formContent {
  border-radius: 10px;
  background: #fff;
  padding: 20px;
  width: 100%;
  max-width: 450px;
  position: relative;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
  border: 1px solid lightgray;
  margin: 0 auto;
}
#formContent .top-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 23px 0 33px;
  margin: 0;
  font-size: 20px !important;
  font-weight: bold;
  color: #1a1a1a;
}
#formContent .top-head .auth-modal-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: none;
  border-radius: 50%;
  margin-left: auto;
  margin-right: 0;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
#formContent .top-head .auth-modal-close:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
#formContent .top-head .auth-modal-close mat-icon {
  color: #606060;
  font-size: 20px;
  width: 20px;
  height: 20px;
  transition: color 0.2s ease;
}
#formContent .top-head .auth-modal-close:hover mat-icon {
  color: #333;
}
#formContent input {
  margin-bottom: 20px;
}
#formContent button.btn-primary {
  font-family: "Raleway";
  background-color: #5ea1d8;
  font-size: 15px;
  cursor: pointer;
  color: white;
  padding: 10px;
  border-radius: 10px;
  border: none;
}
#formContent button.btn-primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

#formFooter {
  background: #fff !important;
  border-top: 1px solid #dce8f1;
  padding: 16px 0 0;
  margin-top: 8px;
  text-align: center;
}
#formFooter button {
  font-family: "Raleway";
  background-color: transparent !important;
  font-size: 15px !important;
  cursor: pointer;
  color: #5ea1d8 !important;
  padding: 10px;
  border-radius: 10px;
  border: none;
  box-shadow: none;
}

.password-row {
  position: relative;
  width: 85%;
  margin: 0 auto;
}
.password-row input {
  width: 100%;
  box-sizing: border-box;
}
.password-row .password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #606060;
  font-size: 20px;
  -webkit-user-select: none;
          user-select: none;
}

input[type=text],
input[type=email],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
}

.password-row input[type=text],
.password-row input[type=password] {
  width: 100%;
  margin: 5px 0 20px;
}

input[type=text]:focus,
input[type=email]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.img-div-left {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;
}

@media (max-width: 460px) {
  .Login > div {
    width: calc(100% - 30px);
  }
  #formContent {
    width: 100% !important;
  }
  #formContent input {
    width: calc(100% - 30px);
  }
  #formContent .password-row {
    width: calc(100% - 30px);
  }
  #formContent .alert-danger {
    width: calc(100% - 30px) !important;
  }
  #formContent .top-head {
    padding: 20px 6px 0 5px;
  }
}
:host-context(body.theme-dark) .Login {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent .top-head {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formContent input {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) #formContent input::-webkit-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input::-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-ms-input-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent input:-moz-placeholder {
  color: rgba(229, 231, 235, 0.5) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}
:host-context(body.theme-dark) #formContent .auth-modal-close:hover mat-icon {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) #formFooter {
  background: #1f2937 !important;
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) input[type=text],
:host-context(body.theme-dark) input[type=email],
:host-context(body.theme-dark) input[type=password] {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) input[type=text]:focus,
:host-context(body.theme-dark) input[type=email]:focus,
:host-context(body.theme-dark) input[type=password]:focus {
  background-color: #1f2937 !important;
  border-bottom-color: #5ea1d8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/change-password/change-password.component.scss"],"names":[],"mappings":"AAAA,iEAAA;AACA;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AACF;AACE;EACE,0BAAA;AACJ;;AAGA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AAAF;;AAGA;EAEE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EAEA,iDAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,SAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;AAAJ;AAEI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAAN;AAEM;EACE,qCAAA;AAAR;AAGM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AADR;AAIM;EACE,WAAA;AAFR;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,2BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AARF;AAUE;EACE,sBAAA;EACA,wCAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AARJ;;AAYA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AATF;AAWE;EACE,WAAA;EACA,sBAAA;AATJ;AAYE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAVJ;;AAcA;;;EAGE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAEA,gCAAA;EAEA,kBAAA;AAXF;;AAcA;;EAEE,WAAA;EACA,kBAAA;AAXF;;AAcA;;;EAGE,sBAAA;EACA,gCAAA;AAXF;;AAcA;EACE,UAAA;EAEA,2BAAA;EAEA,6BAAA;EAEA,sBAAA;AAXF;;AAcA;EAEE,qBAAA;AAXF;;AAcA;EAEE,qBAAA;EACA,6BAAA;AAXF;;AAcA;EAEE,mBAAA;AAXF;;AAcA;EACE;IACE,UAAA;EAXF;EAaA;IACE,UAAA;EAXF;AACF;AAcA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AAZF;;AAeA;EAEI;IACE,wBAAA;EAbJ;EAiBA;IACE,sBAAA;EAfF;EAiBE;IACE,wBAAA;EAfJ;EAkBE;IACE,wBAAA;EAhBJ;EAmBE;IACE,mCAAA;EAjBJ;EAoBE;IACE,uBAAA;EAlBJ;AACF;AAuBE;EACE,oCAAA;EACA,yBAAA;AArBJ;AAwBE;EACE,8BAAA;EACA,iDAAA;EACA,oDAAA;EACA,yBAAA;AAtBJ;AAwBI;EACE,yBAAA;AAtBN;AAyBI;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAvBN;AAyBM;EACE,0CAAA;AAvBR;AAyBM;EACE,0CAAA;AAvBR;AAyBM;EACE,0CAAA;AAvBR;AAyBM;EACE,0CAAA;AAvBR;AA2BI;EACE,yBAAA;AAzBN;AA4BI;EACE,sDAAA;AA1BN;AA6BI;EACE,yBAAA;AA3BN;AA+BE;EACE,8BAAA;EACA,qDAAA;AA7BJ;AAgCE;;;EAGE,oCAAA;EACA,yBAAA;EACA,iDAAA;AA9BJ;AAiCE;;;EAGE,oCAAA;EACA,uCAAA;AA/BJ","sourcesContent":["/* Modal-style layout (matches signup / forget-password modals) */\n.Login {\n  background-color: transparent;\n  height: auto;\n  min-height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n\n  p {\n    font-size: 22px !important;\n  }\n}\n\n.alert-danger {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n  width: 85%;\n  margin: 0px auto 1rem;\n  font-family: \"Raleway\";\n  font-size: 13px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: #fff;\n  padding: 20px;\n  width: 100%;\n  max-width: 450px;\n  position: relative;\n  -webkit-box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  text-align: center;\n  border: 1px solid lightgray;\n  margin: 0 auto;\n\n  .top-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 23px 0 33px;\n    margin: 0;\n    font-size: 20px !important;\n    font-weight: bold;\n    color: #1a1a1a;\n\n    .auth-modal-close {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 32px;\n      height: 32px;\n      border: none;\n      background: none;\n      border-radius: 50%;\n      margin-left: auto;\n      margin-right: 0;\n      padding: 0;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      flex-shrink: 0;\n\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n      }\n\n      mat-icon {\n        color: #606060;\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        transition: color 0.2s ease;\n      }\n\n      &:hover mat-icon {\n        color: #333;\n      }\n    }\n  }\n\n  input {\n    margin-bottom: 20px;\n  }\n\n  button.btn-primary {\n    font-family: \"Raleway\";\n    background-color: #5ea1d8;\n    font-size: 15px;\n    cursor: pointer;\n    color: white;\n    padding: 10px;\n    border-radius: 10px;\n    border: none;\n  }\n\n  button.btn-primary:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n  }\n}\n\n#formFooter {\n  background: #fff !important;\n  border-top: 1px solid #dce8f1;\n  padding: 16px 0 0;\n  margin-top: 8px;\n  text-align: center;\n\n  button {\n    font-family: \"Raleway\";\n    background-color: transparent !important;\n    font-size: 15px !important;\n    cursor: pointer;\n    color: #5ea1d8 !important;\n    padding: 10px;\n    border-radius: 10px;\n    border: none;\n    box-shadow: none;\n  }\n}\n\n.password-row {\n  position: relative;\n  width: 85%;\n  margin: 0 auto;\n\n  input {\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .password-toggle {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    color: #606060;\n    font-size: 20px;\n    user-select: none;\n  }\n}\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px;\n  border-radius: 5px;\n}\n\n.password-row input[type=\"text\"],\n.password-row input[type=\"password\"] {\n  width: 100%;\n  margin: 5px 0 20px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n  -webkit-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  animation-delay: 1s;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10002;\n}\n\n@media (max-width: 460px) {\n  .Login {\n    & > div {\n      width: calc(100% - 30px);\n    }\n  }\n\n  #formContent {\n    width: 100% !important;\n\n    input {\n      width: calc(100% - 30px);\n    }\n\n    .password-row {\n      width: calc(100% - 30px);\n    }\n\n    .alert-danger {\n      width: calc(100% - 30px) !important;\n    }\n\n    .top-head {\n      padding: 20px 6px 0 5px;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .Login {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  #formContent {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4) !important;\n    color: #e5e7eb !important;\n\n    .top-head {\n      color: #e5e7eb !important;\n    }\n\n    input {\n      background: #111827 !important;\n      color: #e5e7eb !important;\n      border-color: rgba(148, 163, 184, 0.3) !important;\n\n      &::-webkit-input-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n      &::-moz-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n      &:-ms-input-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n      &:-moz-placeholder {\n        color: rgba(229, 231, 235, 0.5) !important;\n      }\n    }\n\n    .auth-modal-close mat-icon {\n      color: #94a3b8 !important;\n    }\n\n    .auth-modal-close:hover {\n      background-color: rgba(255, 255, 255, 0.08) !important;\n    }\n\n    .auth-modal-close:hover mat-icon {\n      color: #e5e7eb !important;\n    }\n  }\n\n  #formFooter {\n    background: #1f2937 !important;\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"password\"] {\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  input[type=\"text\"]:focus,\n  input[type=\"email\"]:focus,\n  input[type=\"password\"]:focus {\n    background-color: #1f2937 !important;\n    border-bottom-color: #5ea1d8 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
